<template>
    <div class="container">
        <div class="title is-1 has-text-centered">
            Mentor Analytics
        </div>
        <data-table 
            :rows="rows" 
            :columns="columns" 
            tableClass="table is-fullwidth is-hoverable is-striped is-bordered"
            v-on:row_click="row_click"
            v-on:block="block"
        >
        </data-table>
    </div>
</template>

<script>

import DataTable from '../../components/common/Datatable.vue'
import axios from "../../api/my-axios";

export default {
    components: {
        'data-table': DataTable
    },
    data: function () {
        return {
            columns: [
                {
                    label: 'Mentor Name',
                    field: 'user',
                    sortable: true,
                    filterable: true,
                    is_mentor: true,
                },
                {
                    label: 'No. of Mentees applied',
                    field: 'no_of_mentees_applied',
                    sortable: true,
                },
                {
                    label: 'No. of Mentees accepted',
                    field: 'no_of_mentees_accepted',
                    sortable: true,
                },
                // {
                //     label: 'Average duration of mentorship offered (months)',
                //     field: 'avg_duration_of_mentorship',
                //     sortable: true,
                // },
                {
                    label: 'Actions',
                    field: 'action',
                    block_button: true,
                },
                {
                    label: 'Contact Mentor',
                    field: 'contact',
                    message_button: true,
                }
            ],
            rows: []
        }
    },

    created(){
        this.all_mentors();
    },

    methods: {
        row_click: function (value) {
            console.log("value: ", value);
        },

        all_mentors() {
			axios
				.get("/api/mentor/mentor/all_mentors/")
				.then(response => {
					this.rows = response.data;
                    console.log(this.rows);
				})
				.catch(error => {
					console.error(error);
					this.errors = error.response ? error.response.data : {"detail": [error.message]};
				});
		},

        block(index) {
            axios
				.post(`/api/mentor/mentor/${this.rows[index].user.uid}/block/`, {
					  is_blocked: !this.rows[index].is_blocked,
				})
				.then(_ => {
                    // var row = this.rows[index]
                    // row.is_blocked = !row.is_blocked;
                    // this.rows[index] = row
                    this.all_mentors()
				})
				.catch(error => {
					// this.modal_errors = error.response.data;
				});
        }
    }
};


</script>